import { NgModule } from '@angular/core';
import { PipelinePageCacheService } from './pipeline-page-cache.service';
import { SelectedPipelineCacheService } from './selected-pipeline-cache.service';

@NgModule({
  providers: [PipelinePageCacheService, SelectedPipelineCacheService],
})
export class PipelineCacheModule {}
